var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#424242","fillRule":"evenodd","d":"M12 11.293l5.146-5.147a.5.5 0 0 1 .708.708L12.707 12l5.147 5.146a.5.5 0 0 1-.708.708L12 12.707l-5.146 5.147a.5.5 0 0 1-.708-.708L11.293 12 6.146 6.854a.5.5 0 1 1 .708-.708L12 11.293z"}));
}

Close.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Close;

Close.default = Close;
